import clsx from 'clsx'
import type { MatrixPanelData } from '@/types/dashboards'
import FigureValue, { figureToneClass } from './FigureValue'

interface MatrixPanelProps {
  data: MatrixPanelData
  className?: string
}

/**
 * Category × bucket grid — obligations by due window, exceptions by status.
 * Every cell is a Figure, so every count opens the records behind it.
 */
export default function MatrixPanel({ data, className }: MatrixPanelProps) {
  const { columns, rows } = data

  return (
    <div className={clsx('min-h-0 overflow-x-auto', className)}>
      <table className="dense-table">
        <thead>
          <tr>
            <th className="text-left">Category</th>
            {columns.map((column) => (
              <th key={column.key} className="text-right">
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.key}>
              <td className="whitespace-nowrap text-stone-300">{row.label}</td>
              {columns.map((column, index) => {
                const cell = row.cells[index]
                return (
                  <td
                    key={column.key}
                    className={clsx(
                      'text-right font-medium tabular-nums',
                      cell && figureToneClass(cell.tone),
                    )}
                  >
                    {cell ? (
                      <FigureValue figure={cell} align="right" />
                    ) : (
                      <span className="text-stone-600">--</span>
                    )}
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
      {data.footnote && (
        <p className="mt-2 text-[10px] leading-relaxed text-stone-500">{data.footnote}</p>
      )}
    </div>
  )
}
